import { Route, Redirect } from "react-router-dom";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";

const PrivateRoute = ({ children, requiredPermissions=[],...rest }) => {
    const { getUser } = useContext(AuthContext);
    const user = getUser();
    const hasEveryPermission = requiredPermissions.every(perm => user?.permissions?.includes(perm));
    return <Route {...rest}>{!user ? <Redirect to="/login" /> : (!hasEveryPermission ? <Redirect to="/" /> : children)}</Route>;
};

export default PrivateRoute;
